import { SmartImage } from "@/components/SmartImage";
import { scrollToId } from "@/hooks/useScrollSpy";
import { SECTIONS, RESTAURANT, sectionAnchor } from "@/data/menu";
import { Phone } from "lucide-react";

// Mobile compact header — logo mic + wordmark. Menu-first, no hero.
export const MobileHeader = () => (
  <header
    data-testid="mobile-header"
    className="sticky top-0 z-40 flex h-14 items-center gap-3 border-b border-roty-line bg-roty-paper/95 px-4 backdrop-blur-md lg:hidden"
  >
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="flex items-center gap-2.5"
      data-testid="mobile-logo"
    >
      <SmartImage
        base="logo"
        alt="ROTY FOOD"
        width={40}
        height={44}
        widths={[120, 200]}
        sizes="40px"
        eager
        className="h-9 w-auto"
      />
      <span className="leading-none">
        <span className="block roty-display text-lg text-roty-red">ROTY FOOD</span>
        <span className="text-[9px] font-bold uppercase tracking-[0.22em] text-roty-gold-dark">
          Pizza &amp; Coffee
        </span>
      </span>
    </button>
    <a
      href={`tel:${RESTAURANT.phone.replace(/\s/g, "")}`}
      data-testid="mobile-phone"
      aria-label="Sună la ROTY FOOD"
      className="ml-auto flex h-9 w-9 items-center justify-center rounded-full bg-roty-red text-white"
    >
      <Phone className="h-4 w-4" strokeWidth={2.5} />
    </a>
  </header>
);

// Mobile primary section nav.
export const PrimaryNav = ({ activeSection }) => (
  <nav
    data-testid="primary-nav"
    className="sticky top-14 z-30 flex border-b border-roty-line bg-roty-cream/95 backdrop-blur-md lg:hidden"
  >
    {SECTIONS.map((s) => {
      const active = s.id === activeSection;
      return (
        <button
          key={s.id}
          type="button"
          data-testid={`primary-nav-${s.id}`}
          onClick={() => scrollToId(sectionAnchor(s))}
          className={`relative flex flex-1 min-h-[46px] items-center justify-center py-3 text-center roty-display text-[13px] transition-colors ${
            active ? "text-roty-red" : "text-roty-ink/70"
          }`}
        >
          {s.label}
          {active ? (
            <span className="absolute inset-x-3 bottom-0 h-[3px] bg-roty-red" />
          ) : null}
        </button>
      );
    })}
  </nav>
);
